import { gql } from "@apollo/client"

const PHOTOS_JOB_STEP_FIELDS = gql`
  fragment PhotosJobStepFields on PhotosJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    responseUploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { PHOTOS_JOB_STEP_FIELDS }
